export const create = {
  form: {
    method: 'Method',
    detergentUsed: 'Detergent Used',
    name: 'Method Name',
    no: 'No',
    volume: 'Volume',
    cost: 'Cost',
    time: 'Time',
    washingTime: 'Washing Time',
    companyName: 'Company Name',
    detergentName: 'Detergent Name',
    quantity: 'Quantity',
    waterName: 'Water Name',
    unit: 'Units',
    addNew: 'Add New',
    requireName: 'Please input washing method',
    requireNo: 'Please input no',
    requireVolume: 'Please input volume',
    requireCost: 'Please input cost',
    requireTime: 'Please input time',
    requireWashingTime: 'Please input washing time',
    requireCompanyName: 'Please input company name',
    requireDetergentName: 'Please input detergent name',
    requireQuantity: 'Please input quantity',
    requireUnit: 'Please input unit',
    invalidLetters: 'Only letters are allowed.',
    invalidNumbers: 'Only numbers are allowed.',
  },
  pageHeader: {
    title: 'New Washing Method',
    back: 'Back',
  },
}
